<!--<<div *ngIf="globalLoading || showProgressSpinner" class="spinner-wrapper global-loading">
    <div class="spinner">Loading...</div>
</div>-->
<div class="progressSpinner" *ngIf="globalLoading || showProgressSpinner">
    <p-progressSpinner class="custom-spinner" aria-label="Loading"></p-progressSpinner>
</div>

<div class="main-wrapper" *ngIf="menuLoaded">
    <p-toast key="br" position="top-right"></p-toast>
    <app-sidebar></app-sidebar>
    <div class="page-wrapper">
        <app-navbar></app-navbar>
        <div class="navbar-spacer"></div>
        <div class="lib-user-contracts-component-container" *ngIf="!isDashboard">
            <lib-user-contracts-component *ngIf="contracts" [contracts]="contracts"></lib-user-contracts-component>
        </div>
        <div class="lib-user-contracts-component-container-spacer" *ngIf="!isDashboard">
        </div>
        <div class="page-content">
            <div *ngIf="isLoading" class="spinner-wrapper">
                <div class="spinner">Loading...</div>
            </div>
            <div class="test-scroller">
                <div contentAnimate *ngIf="!isLoading">
                    <div class="row-menubar w-100 px-0 container-fluid"
                         [ngClass]="!isDashboard ? 'bg-show' : 'bg-hide'">
                        <div class="option-btns-container">
                            <div class="row">
                                <ng-container *ngIf="subItems.length > 0 && !isDashboard">
                                    <carousel [itemsPerSlide]="itemsPerSlide" [showIndicators]="false" [interval]="0"
                                              [(activeSlide)]="indexSlide" [singleSlideOffset]="true" [noWrap]="true" (activeSlideChange)="activeSlide($event)"
                                              (slideRangeChange)="slideRangeChange($event)" class="carousel-custom">
                                        <slide *ngFor="let item of subItems; let index = index; trackBy: trackByItems"  [ngClass]="subItems.length ===1 ? 'w-100' : ''">
                                            <div class="cursor-pointer">
                                                <div class="option margin-fix"
                                                     [ngClass]="{'option-active': indexSlide == index}"
                                                     (click)="navigateTo(item, index)">
                                                    {{ item.nombre != undefined ? (item.nombre | translate ) : (item.label | translate )}}
                                                </div>
                                            </div>
                                        </slide>
                                    </carousel>
                                </ng-container>
                            </div>
                        </div>
                        <router-outlet></router-outlet>
                    </div>
                </div>
                <app-footer></app-footer>
            </div>
        </div>


    </div>
</div>
